import { transformUnits } from '@/helpers/unit-formatter/unit-formatter';
import { DEGREE_OUTPUT_LABEL } from '@/helpers/unit-formatter/unit-formatter.constants';
import { FormattedUnitLabels, UnitValue } from '@/helpers/unit-formatter/unit-formatter.types';
import {
  toNumber,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/unit-formatter.utils';

/**
 * Formatter for angular degree values.
 * Rounds to the nearest integer and displays the degree symbol with no space.
 */
export const formatDegree = (unitValue: UnitValue, displayUnits?: string): FormattedUnitLabels => {
  const transformed = transformUnits(unitValue, displayUnits);
  const value = toNumber(transformed.value);

  if (value == null) {
    return unitValueToFormattedUnitLabels({ value: transformed.value, units: undefined });
  }

  const rounded = Math.round(value);

  return {
    valueLabel: `${rounded}`,
    unitsLabel: DEGREE_OUTPUT_LABEL,
    valueUnitsLabel: `${rounded}${DEGREE_OUTPUT_LABEL}`,
  };
};
